import { tv as e } from "tailwind-variants";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/components/Input/Input.tsx
var r = e({
	slots: {
		wrapper: "relative h-9 w-full",
		input: "border-ic-web-border bg-ic-web-background font-ic-web-body text-ic-web-heading placeholder:text-ic-web-text-muted focus-visible:border-ic-web-primary focus-visible:ring-ic-web-primary/40 aria-invalid:border-ic-web-error aria-invalid:focus-visible:ring-ic-web-error/40 flex size-full rounded-md border border-solid px-3 py-1 text-sm shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:ring-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
		addon: "text-ic-web-text-muted absolute inset-y-0 flex w-10 items-center justify-center"
	},
	variants: {
		hasLeft: { true: { input: "pl-10" } },
		hasRight: { true: { input: "pr-10" } }
	}
});
function i({ className: e, wrapperClassName: i, leftContent: a, rightContent: o, ...s }) {
	let c = r({
		hasLeft: !!a,
		hasRight: !!o
	});
	return /* @__PURE__ */ n("div", {
		className: c.wrapper({ className: i }),
		children: [
			/* @__PURE__ */ t("input", {
				...s,
				className: c.input({ className: e })
			}),
			a && /* @__PURE__ */ t("div", {
				className: c.addon({ className: "left-0" }),
				children: a
			}),
			o && /* @__PURE__ */ t("div", {
				className: c.addon({ className: "right-0" }),
				children: o
			})
		]
	});
}
//#endregion
export { i as Input, r as inputVariants };
